(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const states = new WeakMap();
  const pointer = matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const reset = (card) => {
    const state = states.get(card);
    if (!state) return;
    clearTimeout(state.timer);
    state.run++;
    state.overlay.removeAttribute('data-active');
    card.removeAttribute('data-vf-image-index');
  };
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !pointer.matches || reduced.matches) return;
    const card = event.target.closest('product-card');
    if (!card || card.contains(event.relatedTarget)) return;
    let state = states.get(card);
    if (!state) {
      const data = card.querySelector('[data-vf-gallery]');
      const primary = card.querySelector('.product-card__image--primary');
      if (!data || !primary) return;
      let images;
      try { images = [...new Set(JSON.parse(data.textContent))]; } catch { return; }
      if (images.length < 2) return;
      const overlay = primary.cloneNode(false);
      overlay.className = 'vf-gallery-image';
      overlay.removeAttribute('srcset');
      overlay.removeAttribute('sizes');
      overlay.removeAttribute('id');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.alt = '';
      primary.parentElement.append(overlay);
      state = { images, overlay, run: 0, timer: null };
      states.set(card, state);
      card.classList.add('vf-gallery-ready');
      card.classList.remove('product-card--show-secondary-media');
    }
    reset(card);
    const run = state.run;
    card.dataset.vfImageIndex = '0';
    const advance = async (index) => {
      if (run !== state.run || !card.isConnected || document.hidden) return;
      const preload = new Image();
      preload.src = state.images[index];
      try { await preload.decode(); } catch { return; }
      if (run !== state.run || !card.isConnected) return;
      state.overlay.src = state.images[index];
      state.overlay.setAttribute('data-active', '');
      card.dataset.vfImageIndex = String(index);
      if (index < state.images.length - 1) state.timer = setTimeout(() => advance(index + 1), 1000);
    };
    state.timer = setTimeout(() => advance(1), 1000);
  });
  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest('product-card');
    if (card && !card.contains(event.relatedTarget)) reset(card);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('.vf-gallery-ready').forEach(reset);
  });
})();

(() => {
  const closePanel = (card, restoreFocus = false) => {
    const panel = card.querySelector('.vf-quick-panel');
    const toggle = card.querySelector('[data-vf-quick-toggle]');
    if (!panel || !toggle) return;
    panel.hidden = true;
    card.classList.remove('vf-compact-open');
    toggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) toggle.focus({ preventScroll: true });
  };
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-vf-quick-toggle]');
    if (toggle) {
      const card = toggle.closest('product-card');
      const panel = card.querySelector('.vf-quick-panel');
      if (!panel) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const opening = panel.hidden;
      document.querySelectorAll('.vf-compact-open').forEach(other => closePanel(other));
      if (opening) {
        panel.hidden = false;
        card.classList.add('vf-compact-open');
        toggle.setAttribute('aria-expanded', 'true');
        const control = panel.querySelector('input[type="radio"]:not(:disabled), select, [type="submit"]');
        control?.focus({ preventScroll: true });
      }
      return;
    }
    const close = event.target.closest('[data-vf-quick-close]');
    if (close) closePanel(close.closest('product-card'), true);
    document.querySelectorAll('.vf-compact-open').forEach(card => {
      if (!card.contains(event.target)) closePanel(card);
    });
  }, true);
  document.addEventListener('change', event => {
    const control = event.target.closest('.vf-quick-form [name="vf-variant"], .vf-quick-form [data-vf-option]');
    if (!control) return;
    const form = control.closest('form');
    const input = form.querySelector('input[name="id"]');
    const submit = form.querySelector('[type="submit"]');
    if (control.name === 'vf-variant') {
      input.value = control.value;
      submit.disabled = !control.value;
      return;
    }
    const selects = Array.from(form.querySelectorAll('[data-vf-option]'));
    const variants = JSON.parse(form.querySelector('[data-vf-variants]').textContent);
    const selected = selects.map(select => select.value);
    const variant = variants.find(item => item.available && item.options.every((value, index) => value === selected[index]));
    input.value = variant ? variant.id : '';
    submit.disabled = !variant;
    selects.forEach((select, index) => {
      Array.from(select.options).forEach(option => {
        if (!option.value) return;
        option.disabled = !variants.some(item => item.available && item.options[index] === option.value && item.options.every((value, other) => other === index || !selected[other] || value === selected[other]));
      });
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.vf-compact-open').forEach(card => closePanel(card, true));
  });
  document.addEventListener('variant:add', () => {
    document.querySelectorAll('.vf-compact-open').forEach(card => closePanel(card));
  });
})();
  } catch(e) { console.error(e); }
})();

})();
